import './marketing3.css'
import Marketing3Layout from '@/components/marketing3/Marketing3Layout'
import Hero3 from '@/components/marketing3/sections/Hero3'
import ValueStrip3 from '@/components/marketing3/sections/ValueStrip3'
import HowItWorks3 from '@/components/marketing3/sections/HowItWorks3'
import Control3 from '@/components/marketing3/sections/Control3'
import Targets3 from '@/components/marketing3/sections/Targets3'
import MarketIntel3 from '@/components/marketing3/sections/MarketIntel3'
import AiNative3 from '@/components/marketing3/sections/AiNative3'
import MobileApp3 from '@/components/marketing3/sections/MobileApp3'
import IncludedGrid3 from '@/components/marketing3/sections/IncludedGrid3'
import Founder3 from '@/components/marketing3/sections/Founder3'
import FinalCta3 from '@/components/marketing3/sections/FinalCta3'
import { FALLBACK_BRAND } from '@/lib/brand'

/**
 * Landing3 — "Daylight hotel, two rooms of night". Unified light-editorial variant
 * with two dark cinematic islands (hero + AI). Internal preview at /landing3, noindex.
 *
 * Copy is GOVERNED by docs/marketing/2026-07-05-landing3-copy.md and the claims
 * register (docs/marketing/claims-register.md) — do not edit sentences here without
 * updating those first. The plan's §0 do-not-publish list applies to every string on
 * this page (sections, chips, captions, aria-labels, form microcopy, footer). The
 * brand name is injected via the `brand` prop ({BRAND} slots); the repo's internal
 * project name must never appear on this page.
 */

interface Landing3Props {
  brand?: string | null
  submitted?: 'demo' | null
}

export default function Landing3({ brand: brandProp, submitted = null }: Landing3Props) {
  // Strict string guard (same rationale as v1/v2): a misconfigured server can send a
  // truthy non-string — fall back rather than blank-paging the site.
  const brand = typeof brandProp === 'string' && brandProp.trim() !== '' ? brandProp : FALLBACK_BRAND

  return (
    <Marketing3Layout brand={brand}>
      <span id="top" aria-hidden="true" />
      <Hero3 brand={brand} />
      <ValueStrip3 brand={brand} />
      <HowItWorks3 brand={brand} />
      <Control3 brand={brand} />
      <Targets3 brand={brand} />
      <MarketIntel3 brand={brand} />
      <AiNative3 brand={brand} />
      <MobileApp3 brand={brand} />
      <IncludedGrid3 brand={brand} />
      <Founder3 brand={brand} />
      <FinalCta3 brand={brand} submitted={submitted} />
    </Marketing3Layout>
  )
}
